import PropTypes from 'prop-types'
import React from 'react'
import styled, { css } from 'styled-components'

const StyledComponent = styled(({mb, noborder, ...rest}) => <div {...rest} />)`
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.47;
  letter-spacing: normal;
  color: ${p => p.theme.cTextColor};
  border-bottom: ${p => p.noborder ? 'none' : '1px rgba(215,216,218,0.51) solid'};
  padding: ${p => p.theme.s} ${p => p.m === undefined ? p.theme.m : p.m};
  margin-bottom: ${p => p.mb === undefined ? p.theme.s : p.mb};

  @media (min-width: ${p => p.theme.tabletSize}) {
    font-size: 15px;
    color: #333333;
    color: var(--nav-active);
  }

  ${p => p.css}
`

const _CardHeader = (props) => <StyledComponent {...props} />
_CardHeader.propTypes = {
  css: PropTypes.oneOfType(
    [
      PropTypes.string,
      PropTypes.array
    ]),
  mb: PropTypes.oneOfType(
    [
      PropTypes.string,
      PropTypes.number,
    ]
  )
}

export default _CardHeader

